var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "media-bank" },
    [
      _c(
        "div",
        { staticClass: "media-bank__filter media-bank-filter" },
        [
          _vm.filters.type.length
            ? _c("z-tabs", {
                attrs: { "only-visual": "" },
                on: {
                  "toggle-item": function ($event) {
                    return _vm.onTabChange($event)
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "label",
                      fn: function () {
                        return _vm._l(_vm.filters.type, function (type) {
                          return _c(
                            "z-tabs-label",
                            {
                              key: type.id,
                              attrs: {
                                id: type.id,
                                "initial-state": type.selected,
                              },
                            },
                            [_vm._v(_vm._s(_vm.localeText[type.xmlId]))]
                          )
                        })
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2558198478
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _c("z-select", {
            staticClass: "media-bank-filter__select",
            attrs: {
              data: _vm.subjectsOptions,
              placeholder: _vm.subjectsPlaceholder,
              value: _vm.currentSubjectId,
            },
            on: {
              change: function ($event) {
                return _vm.onSelectChange($event)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "media-bank__count" }, [
        _vm._v(_vm._s(_vm.localeText.total) + ": " + _vm._s(_vm.nav.count)),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "media-bank__content" },
        [
          _vm.list && _vm.list.length
            ? _c(
                "div",
                { staticClass: "row" },
                _vm._l(_vm.list, function (card, i) {
                  return _c(
                    "div",
                    {
                      key: card.code,
                      staticClass: "col-default-4 col-v-tablet-6 col-mobile-12",
                    },
                    [
                      _c("media-bank-card", {
                        attrs: { data: card },
                        on: {
                          openModal: function ($event) {
                            return _vm.$root.$bus.$emit("open-modal", {
                              id: "media-modal",
                              index: i,
                            })
                          },
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              )
            : _c("z-not-found"),
          _vm._v(" "),
          _vm.loading
            ? _c(
                "div",
                { staticClass: "media-bank__preloader" },
                [_c("z-preloader")],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "media-bank__pagination" },
        [
          _c("z-pagination", {
            attrs: {
              "show-next": "",
              "show-prev": "",
              data: _vm.paginationData,
            },
            on: { change: _vm.onPageChange },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("z-modal", {
        staticClass: "media-bank__modal",
        attrs: { id: "media-modal", pagination: "", data: _vm.slidesForModal },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }